import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'

const state = {
  loading: true,
  error: null,
  refills: [],
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    count: 20
  },
}

const actions = {
  fetch ({commit, state, dispatch}, companyId) {
    commit('fetch')

    let params = {}

    params.page = state.pagination.pageNumber
    params.per_page = state.pagination.count

    return axios.get(`/v2/admin/company/${companyId}/response-free-refill`, {params})
      .then(response => {
        const data = response.data
        let refills = []
        if (data && data._embedded && data._embedded.refills) {
          refills = data._embedded.refills
        }
        commit('fetchSuccess', {refills: refills, data: data})
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  updateSorting ({ commit, state, dispatch }, data) {
    commit('updateSorting', data)
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {refills, data}) {
    state.pagination.totalPages = data._page_count

    state.refills = refills
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  clear (state) {
    state.refills = [];

    state.pagination = Object.assign(state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      count: 20
    })
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },

  list: (state, getters) => {
    return state.refills
  },

  pagination: (state, getters) => {
    return state.pagination
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
